module.exports = __webpack_public_path__ + "img/homepage_4.0630b05a.svg";